__turbopack_context__.v({
  "active": "ContentsLinks-module__OY2AfG__active",
  "wrapper": "ContentsLinks-module__OY2AfG__wrapper",
});
